import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth/auth.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SessionService } from '../session/session.service';
import { Instance } from "../interfaces/instance.interface";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-loading',
  template: ''
})
export class LoadingComponent implements OnDestroy {
  private routerSubscription: Subscription;
  constructor(
    protected auth: AuthService,
    protected session: SessionService,
    protected translate: TranslateService,
    protected router: Router,
    protected spinner: NgxSpinnerService) {
    this.routerSubscription = router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((navigationEnd: NavigationEnd) => {
        if (!!navigationEnd.url && navigationEnd.url !== '/')
          return;

        spinner.show();

        this.auth.isLoggedIn().subscribe(
          isLoggedIn => {
            if (isLoggedIn) {
              session.getInstances().subscribe(instanceSelector => {
                let lastInstance: Instance;
                if (instanceSelector.instances.length &&
                  instanceSelector.lastLogin &&
                  (lastInstance = instanceSelector.instances.find(i =>
                    i.id === instanceSelector.lastLogin.instanceId &&
                    i.roleType === instanceSelector.lastLogin.roleType))) {
                  this.session.setInstance(lastInstance, instanceSelector.lastLogin.url);
                } else {
                  if (!this.router.url.includes('mina-meddelanden'))
                    router.navigate(['/select-instance'], { queryParams: { enforce: true } });
                }
              });
            } else {
              router.navigate(['/home']);
            }
          }, () => {
            router.navigate(['/login']);
          }, () => {
            spinner.hide();
          });
      });
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }
}
